var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLooptechLogoAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eqNf6p8al0j1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 238.4 35.3",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n#eqNf6p8al0j20 {\nanimation:  ani 600ms ease-in infinite alternate;\n}\n@keyframes ani {\n0%{transform: translate(1rem, -.5rem) rotate(30deg)}\n100%{transform: translate(5.6rem, -.5rem) rotate(30deg)}\n}\n\n"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eqNf6p8al0j18-fill",
    x1: 47.45,
    y1: 36.25,
    x2: 47.45,
    y2: -0.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-0",
    offset: "0%",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-1",
    offset: "0%",
    stopColor: "#000405"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-2",
    offset: "12%",
    stopColor: "#000f15"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-3",
    offset: "20%",
    stopColor: "#00222f"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-4",
    offset: "28%",
    stopColor: "#003c53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-5",
    offset: "36%",
    stopColor: "#005e81"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-6",
    offset: "45%",
    stopColor: "#0086b9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-7",
    offset: "52%",
    stopColor: "#00adee"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-8",
    offset: "57%",
    stopColor: "#00a3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-9",
    offset: "65%",
    stopColor: "#0089bd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-10",
    offset: "77%",
    stopColor: "#005f83"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-11",
    offset: "91%",
    stopColor: "#002635"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j18-fill-12",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eqNf6p8al0j20-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "eqNf6p8al0j20-filter-blur-0",
    stdDeviation: "2,0",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eqNf6p8al0j22-fill",
    x1: 47.45,
    y1: 36.25,
    x2: 47.45,
    y2: -0.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-0",
    offset: "0%",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-1",
    offset: "0%",
    stopColor: "#000405"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-2",
    offset: "12%",
    stopColor: "#000f15"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-3",
    offset: "20%",
    stopColor: "#00222f"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-4",
    offset: "28%",
    stopColor: "#003c53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-5",
    offset: "36%",
    stopColor: "#005e81"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-6",
    offset: "45%",
    stopColor: "#0086b9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-7",
    offset: "52%",
    stopColor: "#00adee"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-8",
    offset: "57%",
    stopColor: "#00a3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-9",
    offset: "65%",
    stopColor: "#0089bd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-10",
    offset: "77%",
    stopColor: "#005f83"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-11",
    offset: "91%",
    stopColor: "#002635"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqNf6p8al0j22-fill-12",
    offset: "100%",
    stopColor: "#000"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3,34L0,34L0,0.8h6.7v26.7h17.8c1,1.6,2.2,2.9,3.7,4c.6.5,1.3.9,2,1.3c0,0,0,0,0,0s.1,0,.1.1c.9.4,1.9.8,3,1.1Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,34.3h-6.7v-33.6h23.3c2.7,0,5.2,1,7.1,2.9s2.9,4.4,2.9,7.1-1,5.2-2.9,7.1-4.4,2.9-7.1,2.9h-14.6L88.9,14h8.3c.9,0,1.8-.3,2.4-1c.6-.6,1-1.5,1-2.4s-.3-1.8-1-2.4c-.6-.6-1.5-1-2.4-1h-16.7v27.1h.2Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.6,7.4v26.6h-6.7v-26.6h-11.3c-.4-1.3-1-2.5-1.8-3.6-1-1.3-2.4-2.4-3.9-3.1h40.1v6.7h-16.4Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.9,14v6.7h15v-6.7h-15Zm.1-6.6c6.7,0,13.4.1,20.2.1c1-2,2.5-3.6,4.3-4.9c1.1-.8,2.4-1.4,3.7-1.8h-28.2",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.8,34h28.2c-1.3-.4-2.6-1-3.7-1.8-1.8-1.3-3.3-2.9-4.3-4.9-6.7,0-13.4.1-20.2.1",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180.6,7.4h22.5v-6.7h-22.5c-4.4-.1-8.7,1.7-11.8,4.9-3.2,3.1-4.9,7.4-4.9,11.8-.1,4.4,1.7,8.7,4.9,11.8c3.1,3.2,7.4,4.9,11.8,4.9h22.5v-6.7h-22.5c-2.7,0-5.2-1-7.1-2.9s-2.9-4.4-2.9-7.1s1-5.2,2.9-7.1s4.4-2.9,7.1-2.9Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7,20.7v13.3h-6.7v-33.3h6.7v13.3h20v-13.3h6.7v33.3h-6.7v-13.3h-20Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3,34L0,34L0,0.8h6.7v26.7h17.8c1,1.6,2.2,2.9,3.7,4c.6.5,1.3.9,2,1.3c0,0,0,0,0,0s.1,0,.1.1c.9.4,1.9.8,3,1.1Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,34.3h-6.7v-33.6h23.3c2.7,0,5.2,1,7.1,2.9s2.9,4.4,2.9,7.1-1,5.2-2.9,7.1-4.4,2.9-7.1,2.9h-14.6L88.9,14h8.3c.9,0,1.8-.3,2.4-1c.6-.6,1-1.5,1-2.4s-.3-1.8-1-2.4c-.6-.6-1.5-1-2.4-1h-16.7v27.1h.2Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.6,7.4v26.6h-6.7v-26.6h-11.3c-.4-1.3-1-2.5-1.8-3.6-1-1.3-2.4-2.4-3.9-3.1h40.1v6.7h-16.4Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.9,14v6.7h15v-6.7h-15Zm.1-6.6c6.7,0,13.4.1,20.2.1c1-2,2.5-3.6,4.3-4.9c1.1-.8,2.4-1.4,3.7-1.8h-28.2",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.8,34h28.2c-1.3-.4-2.6-1-3.7-1.8-1.8-1.3-3.3-2.9-4.3-4.9-6.7,0-13.4.1-20.2.1",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.6,7.4h22.5v-6.7h-22.5c-4.4-.1-8.7,1.7-11.8,4.9-3.2,3.1-4.9,7.4-4.9,11.8-.1,4.4,1.7,8.7,4.9,11.8c3.1,3.2,7.4,4.9,11.8,4.9h22.5v-6.7h-22.5c-2.7,0-5.2-1-7.1-2.9s-2.9-4.4-2.9-7.1s1-5.2,2.9-7.1s4.4-2.9,7.1-2.9Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7,20.7v13.3h-6.7v-33.3h6.7v13.3h20v-13.3h6.7v33.3h-6.7v-13.3h-20Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46,2.6c-4.7,3-7.8,8.2-8.1,14.1h-14.9c.6-8.6,7.8-15.4,16.5-15.4c2.4,0,4.5.5,6.5,1.3Z",
    opacity: 0.98,
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9,18.2c-.3,9-7.7,16.1-16.7,16.1-2.7,0-5.2-.6-7.5-1.8c4.8-3,8-8.3,8.2-14.4h16Z",
    opacity: 0.98,
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5,17.4h-16.3v.2c0,9.3-7.6,16.9-16.9,16.9s-16.9-7.5-16.9-16.9v-.2h16.3c0-9.3,7.6-16.9,16.9-16.9s16.9,7.6,16.9,16.9Z",
    fill: "url(#eqNf6p8al0j18-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    clipPath: "url(#eqNf6p8al0j21)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "eqNf6p8al0j20",
    width: 6,
    height: 60,
    rx: 0,
    ry: 0,
    filter: "url(#eqNf6p8al0j20-filter)",
    fill: "#fff",
    strokeWidth: 0
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "eqNf6p8al0j21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5,17.4h-16.3v.2c0,9.3-7.6,16.9-16.9,16.9s-16.9-7.5-16.9-16.9v-.2h16.3c0-9.3,7.6-16.9,16.9-16.9s16.9,7.6,16.9,16.9Z",
    fill: "url(#eqNf6p8al0j22-fill)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLooptechLogoAnimated);
export default __webpack_public_path__ + "static/media/looptech-logo-animated.65d9acb5f449d0d3b27c0c858b053f47.svg";
export { ForwardRef as ReactComponent };